// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.text {
  font-size: 1.2rem;
  text-align: center;
}

.loading {
  width: 100%;
  margin: auto;
  margin-top: 110px;
}

.loading mat-spinner {
  margin: auto;
}

.description {
  margin-top: 20px;
}

.error {
  text-align: center;
  color: crimson;
}`, "",{"version":3,"sources":["webpack://./src/app/+home/+my-libraries/view-sites/shared/components/dialog-create-site/dialog-create-site.component.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,kBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,kBAAA;EACA,cAAA;AACF","sourcesContent":[".text {\r\n  font-size: 1.2rem;\r\n  text-align: center;\r\n}\r\n\r\n.loading {\r\n  width: 100%;\r\n  margin: auto;\r\n  margin-top: 110px;\r\n}\r\n\r\n.loading mat-spinner {\r\n  margin: auto;\r\n}\r\n\r\n.description {\r\n  margin-top: 20px;\r\n}\r\n\r\n.error {\r\n  text-align: center;\r\n  color: crimson;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
